import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames/bind';

import s from './RadioButtonGroup.scss';

const cx = cls.bind(s);

const wrapperMainLocator = 'RadioButtonGroup';
const optionMainLocator = 'RadioButtonOption';

class RadioButtonGroup extends React.PureComponent {
  static propTypes = {
    defaultIndex: PropTypes.number,
    disabled: PropTypes.bool,
    stretched: PropTypes.bool,
    isWordWrapAllowed: PropTypes.bool,
    optionClassName: PropTypes.string,
    optionStyles: PropTypes.object,
    isMobile: PropTypes.bool,
    optionSelectedClassName: PropTypes.string,
    specificLocators: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  };

  static defaultProps = {
    defaultIndex: 0,
    disabled: false,
    stretched: false,
    optionStyles: {},
    isMobile: false,
    isWordWrapAllowed: false,
    specificLocators: [],
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.state = {
      selectedIndex: props.defaultIndex,
    };
  }

  handleClick(index) {
    const { disabled } = this.props;

    if (disabled) {
      return;
    }

    this.setState({
      selectedIndex: index,
    });

    const { onChange, options } = this.props;
    if (onChange) {
      onChange(options[index].value, index);
    }
  }

  componentWillReceiveProps(next) {
    const { defaultIndex: defaultIndexNext } = next;

    const { defaultIndex } = this.props;

    if (defaultIndexNext !== defaultIndex) {
      this.setState({
        selectedIndex: defaultIndexNext,
      });
    }
  }

  render() {
    const {
      isWide,
      options,
      className,
      stretched,
      disabled,
      optionClassName,
      optionSelectedClassName,
      optionStyles,
      isMobile,
      isWordWrapAllowed,
      specificLocators,
    } = this.props;

    const { selectedIndex } = this.state;

    const withSeparator = options.length > 2;
    const optionWidth = stretched ? `${100 / options.length}%` : undefined;
    return (
      <div
        className={cx('group', className, {
          'group--stretched': stretched,
          'group--wrapable': isWordWrapAllowed,
        })}
        data-locator={cls(wrapperMainLocator, specificLocators)}
      >
        {options.map(({ value, name, specificLocators: optionSpecificLocators }, index) => {
          const onClick = this.handleClick.bind(this, index);
          const selected = selectedIndex === index;
          return (
            <span
              key={index}
              className={cx('option', optionClassName, selected && optionSelectedClassName, {
                'option--selected': selected,
                'option--withSeparator': withSeparator,
                'option--isWide': isWide,
                'option--wrapable': isWordWrapAllowed,
                'option--disabled': disabled,
                'option--stretched': stretched,
                'option--isMobile': isMobile,
              })}
              style={{ width: optionWidth, ...optionStyles }}
              onClick={onClick}
              data-test={value}
              data-locator={cls(optionMainLocator, optionSpecificLocators)}
            >
              {name}
            </span>
          );
        })}
      </div>
    );
  }
}

export default RadioButtonGroup;
